import { useEffect, useState, useMemo } from 'react'
import { useFormikContext } from 'formik'
import axios from 'axios'
import CustomSelect from '@/shared/components/custom-select'
import { toOptions } from '@/utils'
import get from 'lodash.get'

export function MutualitySelect({ name = 'mutuality_id', required = false, allowNull = false }) {
  const { values, setFieldValue } = useFormikContext()
  const [mutualities, setMutualities] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    axios.get('/api/v1/mutualities')
      .then(response => {
        setMutualities(response.data.mutualities)
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [])

  const options = useMemo(() => {
    const baseOptions = toOptions({ data: mutualities })
    return allowNull
      ? [{ label: 'Sin seleccionar', value: null }, ...baseOptions]
      : baseOptions
  }, [mutualities, allowNull])

  const currentValue = useMemo(() => {
    const selected = get(values, name)
    return options.find(opt => opt.value === selected) || null
  }, [options, values, name])

  return (
    <CustomSelect
      required={required}
      placeholder="Mutualidad"
      name={name}
      isLoading={loading}
      options={options}
      value={currentValue}
      onChange={({ value }) => setFieldValue(name, value)}
    />
  )
}